import { useState, useEffect } from 'react'
import { getFactionsAPI } from '../services/factions'

export default function UseFactions(orgId, divisionId, factionId, departmentId, searchs, isPreload = false) {
  const [data, setData] = useState([])
  useEffect(() => {
    const param = {
      orgId,
      divisionId,
      searchs
    }
    const getData = async () => {
      const result = await getFactionsAPI(param)
      if (!result) return
      if (result.result.length > 0) {
        const newData = result.result.map((d, i) => {
          return {
            value: d.id,
            label: `${d.faction_en} (${d.faction})`,
            count_emp: d.count_emp,
            data: d.faction
          }
        }) 

        setData(newData)
      } else {
        setData([])
      }
    }
    if (divisionId && orgId && (isPreload || (factionId === 0 && departmentId === 0))) {
      getData()
    }
  }, [divisionId, orgId, searchs, isPreload])

  return data
}
